import { expectedModulesOrder } from './chunk-6DKOVDY4.mjs';

// src/helpers/factories/settings/roleModulesFactory.ts
var roleModulesFactory = (t, homeScreenPermissions) => {
  const moduleDefault = "ModuleDefault";
  const moduleAvailable = "ModuleAvailable";
  const modules = Object.entries(homeScreenPermissions).filter((property) => {
    const defaultModule = property[0];
    const available = defaultModule.replace(moduleDefault, moduleAvailable);
    return defaultModule.includes(moduleDefault) && homeScreenPermissions[available];
  }).reduce(
    (acc, [field, permission], index) => {
      return [
        ...acc,
        {
          id: index,
          title: t(
            `settingsModule.roleDetailsSettings.home.homeScreenDefaultModules.modules.${field}`
          ),
          path: field,
          description: field.replace(moduleDefault, ""),
          isActive: permission,
          isStatusActive: permission
        }
      ];
    },
    []
  );
  const orderedModuleArray = modules.sort((a, b) => {
    const moduleA = a.description;
    const moduleB = b.description;
    return (expectedModulesOrder.indexOf(moduleA) !== -1 ? expectedModulesOrder.indexOf(moduleA) : Infinity) - (expectedModulesOrder.indexOf(moduleB) !== -1 ? expectedModulesOrder.indexOf(moduleB) : Infinity);
  });
  return orderedModuleArray;
};

export { roleModulesFactory };
